import { BRAND, MENU } from "@/data/content";
import { MaskLine, FadeUp } from "@/components/Reveal";

function Ladder() {
  return (
    <div className="mt-2.5 flex gap-2">
      {["₹10", "₹15", "₹20"].map((p) => (
        <span
          key={p}
          className="rounded-full border border-gold-dark/40 px-2.5 py-0.5 text-[11px] font-semibold text-gold-dark"
        >
          {p}
        </span>
      ))}
    </div>
  );
}

function ItemRow({ item }) {
  const slug = item.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  return (
    <div data-testid={`menu-item-${slug}`} className="flex items-start py-5 border-b border-ink/10 group">
      {item.img && (
        <img
          src={item.img}
          alt={item.name}
          loading="lazy"
          className="w-14 h-14 rounded-xl object-cover border border-ink/10 mr-4 shrink-0 group-hover:scale-[1.04] transition-transform duration-300"
        />
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h4 className="font-display font-semibold text-lg leading-snug">{item.name}</h4>
          {item.tag && (
            <span className="rounded-full bg-gold/20 text-gold-dark px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider">
              {item.tag}
            </span>
          )}
        </div>
        <p className="mt-1 text-sm text-ink/60 leading-relaxed">{item.desc}</p>
        {item.ladder && <Ladder />}
      </div>
      <span className="dots" aria-hidden="true" />
      <div className="text-right shrink-0">
        <p className="font-display font-semibold text-xl text-ink leading-none">{item.price}</p>
        <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-ink/45">{item.unit}</p>
      </div>
    </div>
  );
}

export default function MenuSection() {
  return (
    <section id="menu" data-testid="menu-section" className="relative bg-cream text-ink py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <FadeUp>
              <p className="text-[11px] uppercase tracking-[0.3em] text-gold-dark">The Complete Menu</p>
            </FadeUp>
            <h2 className="mt-4 font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight">
              <MaskLine>Everything, made fresh daily</MaskLine>
            </h2>
          </div>
          <FadeUp delay={0.15}>
            <p className="text-sm text-ink/55 max-w-xs md:text-right leading-relaxed">
              Prices in INR. Items marked “at counter” are priced by weight &amp; batch — ask Bappu for
              today’s rate. Call ahead on {BRAND.phones[0]}.
            </p>
          </FadeUp>
        </div>

        <div className="mt-14 md:mt-20 space-y-16 md:space-y-20">
          {MENU.map((cat) => (
            <div key={cat.num} data-testid={`menu-category-${cat.num}`}>
              <FadeUp className="flex items-baseline gap-5 border-b-2 border-ink/80 pb-4">
                <span className="font-display text-4xl sm:text-5xl font-light text-gold-dark/35 leading-none">
                  {cat.num}
                </span>
                <div>
                  <h3 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">{cat.title}</h3>
                  <p className="mt-1 text-sm text-ink/55">{cat.note}</p>
                </div>
              </FadeUp>
              <div className="grid sm:grid-cols-2 gap-x-12">
                {cat.items.map((item) => (
                  <ItemRow key={item.name} item={item} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
